import { render, staticRenderFns } from "./WfDevComplaintModal.Style#Drawer.vue?vue&type=template&id=77120b96&scoped=true&"
import script from "./WfDevComplaintModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./WfDevComplaintModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./WfDevComplaintModal.Style#Drawer.vue?vue&type=style&index=0&id=77120b96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77120b96",
  null
  
)

export default component.exports